'use strict';

var React = require('react');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Checkbox = React.forwardRef(({ label, checked, containerClassName, checkboxHidden, ...props }, ref) => {
    const checkboxRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (!checkboxRef.current)
            return;
        if (checked === true) {
            checkboxRef.current.checked = true;
            checkboxRef.current.indeterminate = false;
        }
        else {
            checkboxRef.current.checked = false;
            checkboxRef.current.indeterminate = checked === 'indeterminate';
        }
    }, [checked]);
    const handleLabelKeyDown = (event) => {
        if (event.key === ' ') {
            checkboxRef.current?.click();
        }
    };
    return (React__default.default.createElement(styles.Styled.Container, { className: containerClassName, onKeyDown: handleLabelKeyDown, tabIndex: 0, role: "checkbox", ref: ref, "aria-disabled": props.disabled },
        React__default.default.createElement(styles.Styled.Input, { type: "checkbox", ref: checkboxRef, ...props }),
        checkboxHidden ? React__default.default.createElement(styles.Styled.BoxPlaceholder, null) : React__default.default.createElement(styles.Styled.Box, null),
        label ? React__default.default.createElement(styles.Styled.Label, null, label) : null));
});

exports.Checkbox = Checkbox;
//# sourceMappingURL=component.js.map
